import { SSO_SESSION_KEYS } from '../config/msalConfig';

/**
 * Path-only return URL from Funnel Fuel (must start with /, no scheme).
 */
export function normalizeReturnPath(returnUrl) {
  if (!returnUrl || typeof returnUrl !== 'string') return '/';
  const t = returnUrl.trim();
  if (!t.startsWith('/') || t.startsWith('//')) return '/';
  return t;
}

export function clearSsoSessionStorage() {
  sessionStorage.removeItem(SSO_SESSION_KEYS.parentOrigin);
  sessionStorage.removeItem(SSO_SESSION_KEYS.returnPath);
}

/**
 * Full-page navigation back to Funnel Fuel with id_token in URL hash (fragment not sent to server).
 */
export function redirectParentWithIdToken(parentOrigin, returnPath, idToken) {
  const path = normalizeReturnPath(returnPath);
  clearSsoSessionStorage();
  window.location.replace(
    `${parentOrigin}${path}#ms_sso_id_token=${encodeURIComponent(idToken)}`
  );
}

export function redirectParentWithError(parentOrigin, returnPath, message) {
  const path = normalizeReturnPath(returnPath);
  clearSsoSessionStorage();
  const msg = encodeURIComponent(message || 'Microsoft sign-in did not complete.');
  window.location.replace(`${parentOrigin}${path}#ms_sso_error=${msg}`);
}
